if (!customElements.get("announcement-bar-modal")) {
  class AnnouncementBarModal extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector("dialog");
      this.triggerId = this.dataset.triggerId;
      this.trigger = document.querySelector(
        `[data-block-id="${this.triggerId}"]`
      );
      this.modalContent = this.querySelector(".dialog-content");
      this.closeBtn = this.querySelector(".dialog-close");
    }

    connectedCallback() {
      this.trigger.addEventListener("click", () => {
        this.open();
      });

      this.closeBtn.addEventListener("click", () => {
        this.close();
      });
    }

    open() {
      this.dialog.showModal();
      window.addEventListener("click", this.handleOffClick.bind(this), true);
    }

    close() {
      this.dialog.close();
      window.removeEventListener("click", this.handleOffClick.bind(this), true);
    }

    handleOffClick(event) {
      if (!this.modalContent.contains(event.target)) {
        this.close();
      }
    }
  }

  customElements.define("announcement-bar-modal", AnnouncementBarModal);
}